var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.6,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 4.4h-1.4V3h-1.4v1.4H8.7V3H7.3v1.4H5.9a1.4 1.4 0 0 0-1.4 1.4v9.8A1.4 1.4 0 0 0 5.9 17h9.8a1.4 1.4 0 0 0 1.4-1.4V5.8a1.4 1.4 0 0 0-1.4-1.4zm-3.212 10.5-1.714-.9-1.715.9.328-1.91L8 11.639l1.917-.279.858-1.736.858 1.736 1.917.279-1.387 1.352.327 1.909zm3.212-7H5.9V6.5h9.8z",
    transform: "translate(-4.5 -3)",
    fill: "#3c2f87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9f06c90370ee8ee25cf5dfac03e5e4fc.svg";
export { ForwardRef as ReactComponent };